import { useState } from 'react';
import {
    Grid, IconButton,
    Toolbar, Tooltip, useTheme,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import MuiAppBar, {
    AppBarProps as IMuiAppBarProps,
} from '@mui/material/AppBar';
import { ProfileMenu } from '@tap/tap-ui';
import MenuIcon from '@mui/icons-material/Menu';
import { ServicesMenuDrawer, ServiceDataList, Breadcrumbs } from '@tap/tap-ui';
import { AppBaseUrl } from '../../env';
import { RoutesData } from '../../routes/routes';
import { createPortal } from 'react-dom';
import React from 'react';

/*
*   Хэдер (панель в верху страницы)
*/

type IAppBarProps = {
    drawerwidth: number,
    openServicesMenu: boolean,
} & IMuiAppBarProps

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'openServicesMenu',
})<IAppBarProps>(({ drawerwidth, theme, openServicesMenu }) => ({
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: theme.palette.background.navbar,
    boxShadow: 'none',
    '.MuiToolbar-root': {
        borderBottom: '1px solid #D7D7D7',
        color: '#666666',
        ...(openServicesMenu && {
            paddingLeft: '15px',
        }),
    },
    // расчет сдвига при открытии бокового меню
    ...(openServicesMenu && {
        marginLeft: drawerwidth,
        width: `calc(100% - ${drawerwidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
    color: '#666666',
}));

const ToolbarPortalId = 'header-toolbar-portal';

const HeaderToolbarOutlet = () => {
    return (<div id={ToolbarPortalId}></div>);
}

export const HeaderToolbarPortal: React.FunctionComponent<React.PropsWithChildren> = ({
    children,
}) => {
    const [toolbarOutlet, setToolbarOutlet] = useState<HTMLDivElement>();

    React.useEffect(() => {
        const container = document.getElementById(ToolbarPortalId) as HTMLDivElement;
        if (container) {
            setToolbarOutlet(container);
        }
    }, []);

    if (!toolbarOutlet)
        return null;

    return createPortal(<>{children}</>, toolbarOutlet);
};


export default function Header() {

    const theme = useTheme();
    const [openServicesMenu, setOpenServicesMenu] = useState(false);
    const [firstOpenServicesMenu, setFirstOpenServicesMenu] = useState(false);
    const openMenuWidth = 800;

    return (
        <AppBar position='fixed'
            drawerwidth={openMenuWidth}
            openServicesMenu={openServicesMenu}>
            <Toolbar>
                <Grid container
                    item
                    alignItems='center'>
                    {!openServicesMenu &&
                        <Grid
                            container
                            item
                            alignItems='center'
                            wrap='nowrap'
                            sx={{
                                height: '43px',
                                '@keyframes hide': {
                                    '0%': {
                                        opacity: 0,
                                    },
                                    '100%': {
                                        opacity: 1,
                                    },
                                },
                                ...(firstOpenServicesMenu && { animation: `hide 1000ms ${theme.transitions.easing.easeInOut}` }),
                            }}
                        >
                            <Tooltip title={'Другие сервисы'}>
                                <IconButton
                                    color='inherit'
                                    aria-label='open drawer'
                                    onClick={() => { setOpenServicesMenu(true); setFirstOpenServicesMenu(true); }}
                                    edge='start'
                                    sx={{
                                        marginRight: '36px',
                                        marginBottom: '3px',
                                    }}
                                >
                                    <MenuIcon />
                                </IconButton>
                            </Tooltip>

                            <Breadcrumbs routes={RoutesData} />
                        </ Grid>}
                </ Grid>

                {/* Меню все сервисы */}
                <ServicesMenuDrawer
                    baseUrl={AppBaseUrl}
                    openServicesMenu={openServicesMenu}
                    openMenuWidth={openMenuWidth}
                    handleServicesMenuClose={() => setOpenServicesMenu(false)}
                    serviceList={ServiceDataList} />

                <HeaderToolbarOutlet />

                {/* Выпадающее меню в хедере с кнопкой выхода из профиля */}
                <ProfileMenu />

            </Toolbar>
        </AppBar >
    );
}
